export const environment = {
  production: false,
  url: "https://uat-tune-api-motor.policystreet.app",
  mainsiteUrl: "https://policystreet.app",
  crmUrl: "https://uat-tune-api-crm.policystreet.app",
  signalrHubUrl: "https://uat-tune-api-crm.policystreet.app/hub",
  googleTagId: "",
  cleverTapId: "TEST-ZK9-6ZK-696Z",
  // Shopback is enabled on staging + UAT only; keep it off in production.
  enableShopback: true,
  grabMiniApp: {
    clientId: "e4e4ed59bfd74f499329d42873b4a29b",
    redirectUri:
      "https://grabc.policystreet.app/grab/oauth/authentication-callback",
    webviewUrl: "https://api.stg-myteksi.com",
    env: "staging"
  },
  clarityProjectId: "z1npi1e4dq"
};
